const engineeringExample = `
 <div className="mt-2">
  <p><strong style="color: rgb(16, 65, 130);">Contexte :</strong></p>
  <ul>
    <li>Acteur majeur du secteur pétrolier, le Groupe XXX offre à l’ensemble de ses points de vente, via XXX
      (filiale), des solutions …
    </li>
    <li>Intervention au sein du bureau d’ingénieurs groupe, dans le cadre de la création d’une nouvelle
      plateforme pétrolière
    </li>
  </ul>
  <p><strong style="color: rgb(16, 65, 130);">Périmètre :</strong></p>
  <ul>
    <li>XX Pays - XXX salariés – XX usines – typologie(s) de population(s) (sièges, cadre, ETAM…)</li>
    <li>Département ingé de XX personnes – Reporting au DRH Monde</li>
  </ul>
  <p><strong style="color: rgb(16, 65, 130);">Objectifs :</strong></p>
  <ul>
    <li>Objectif 1</li>
    <li>Objectif 2</li>
  </ul>
  <p><strong style="color: rgb(16, 65, 130);">Réalisations :</strong></p><p><span
    style="color: rgb(16, 65, 130);">Intitulé du sujet / projet (1)</span></p>
  <ul>
    <li>Superviser les travaux</li>
    <li>Mise en place des process qualité</li>
    <li>Etc…</li>
  </ul>
  <p><span style="color: rgb(16, 65, 130);">Intitulé du sujet / projet (2)</span></p>
  <ul>
    <li>Mise en place et respect des normes HSE</li>
    <li>Etc…</li>
  </ul>
  <p><strong style="color: rgb(16, 65, 130);">Résultats :</strong></p>
  <ul>
    <li>Etc</li>
  </ul>
</div>
`

export {engineeringExample}